<template>
  <!-- 周报 -->
  <div class="weekly">
    <!-- 头部——选择 -->
    <div class="head">
      <el-radio-group v-model="type" size="small">
        <el-radio-button label="1">
          我发出的
        </el-radio-button>
        <el-radio-button label="2">
          我收到的
          <el-badge :hidden="!unreadNum" :value="unreadNum" class="item"></el-badge>
        </el-radio-button>
      </el-radio-group>
    </div>

    <!-- 内容——筛选条件和表 -->
    <div class="content">
      <!-- 我发起的周报 -->
      <template v-if="type==='1'">
        <issued></issued>
      </template>

      <!-- 我收到的周报 -->
      <template v-if="type==='2'">
        <received></received>
      </template>
    </div>
  </div>
</template>

<script>
import issued from "./components/issued.vue";
import received from "./components/received.vue";
import weeklyService from "@/CommonDP/service/weekly-service";
import { mapState } from "vuex";

export default {
  name: "Weekly",
  components: { issued, received },
  data() {
    return {
      type: "1", // 发出的, 收到的
      unreadNum: 0 // 未读数量
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  mounted() {
    this.getUnreadNum();
  },
  methods: {
    // 我收到的-未读数量
    async getUnreadNum() {
      const res = await weeklyService.getUnreadNum(this.enterpriseId);
      this.unreadNum = res.data;
    }
  }
};
</script>

<style lang='scss' scoped>
.weekly {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .head {
    width: 100%;
    padding: var(--middle-space) var(--big-space);
    border-bottom: 1px solid #e5e8f1;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    /deep/.el-badge {
      right: -14px;
      top: -8px;
      z-index: 99;
      position: absolute;
      .el-badge__content {
        line-height: 15px;
      }
    }
  }

  .content {
    width: 100%;
    height: 1px;
    flex-grow: 1;
  }
}
</style>
